"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsViewScan = void 0;
const core_1 = require("@material-ui/core");
const ndc_barcode_scan_1 = require("client/components/ndc-barcode-scan");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const styles = core_1.createStyles({
    rowDetails: {
        padding: "12px 16px",
        flex: "1 0 120px"
    },
    invalid: {
        background: "rgba(193, 30, 30, 0.05)"
    },
    invalidMessage: {
        marginTop: "15px",
        color: "red"
    }
});
const decorate = core_1.withStyles(styles);
let LabelsViewScanUnstyled = class LabelsViewScanUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.renderPreview = (ndcScan) => {
            // console.info("inside renderpreview");
            // console.info("ndcScan", ndcScan);
        };
        this.handleSubmit = async (scannedList) => {
            this.props.onSubmit(scannedList);
        };
    }
    render() {
        return (React.createElement(ndc_barcode_scan_1.NdcBarcodeScan, { autoSubmit: true, onCancel: this.props.onCancel, onSubmit: this.handleSubmit, renderPreview: this.renderPreview }));
    }
};
LabelsViewScanUnstyled = __decorate([
    mobx_react_1.observer
], LabelsViewScanUnstyled);
exports.LabelsViewScan = decorate(LabelsViewScanUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/modules/labels-view-scan/labels-view-scan.tsx
// module id = 3703
// module chunks = 0